import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const cards = [
  {
    title: "Congé sans traitement",
    description:
      "Demande de congé sans traitement à temps complet ou réduction de tâche.",
    to: "/formulaireDemandeCongeSansTraitement",
    icon: "check_box",
  },
  {
    title: "Congés parentaux",
    description:
      "Demande de congé de maternité, de paternité (ou du parent qui n'a pas donné naissance) ou d'adoption.",
    to: "/forumulaireDemandeCongeDroitParentaux",
    icon: "account_circle",
  },
  {
    title: "Traitement différé",
    description: "Demande de congé à traitement différé.",
    to: "/formulaireCongeTraitementDiffere",
    icon: "schedule",
  },
  {
    title: "Changement de discipline",
    subtitle: "(Secteur jeunes)",
    description:
      "Demande de changement de discipline sur la liste de priorité.",
    to: "/formulaireChangementDiscipline",
    icon: "edit",
  },
  {
    title: "Préférence pour une ou des disciplines",
    subtitle: "(Secteur jeunes)",
    description:
      "Soumission des préférences de disciplines pour la liste de priorité.",
    to: "/formulairePreferenceDiscipline",
    icon: "note_add",
  },
];

// ── To disable a form temporarily, add disabled: true to its card above ──

function Home() {
  useEffect(() => {
    document.title = "SEVF | Portail de formulaires électroniques";
  }, []);

  return (
    <div
      className="font-body text-on-surface"
      style={{
        backgroundColor: "#f9f9ff",
        flex: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header — fixed, full width, no inner max-width centering */}
      <header
        className="fixed top-0 z-50 shadow-sm"
        style={{
          left: 0,
          right: 0,
          background: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(12px)",
        }}
      >
        <div
          className="flex justify-between items-center"
          style={{ padding: "0.75rem 1.5rem" }}
        >
          <img
            src="logo.jpg"
            alt="Logo CSSCDR"
            style={{ height: "64px", width: "auto", objectFit: "contain" }}
          />
        </div>
      </header>

      {/* Main — full width, inner wrapper handles centering */}
      <main style={{ flexGrow: 1, paddingTop: "8rem", paddingBottom: "5rem" }}>
        <div
          style={{ maxWidth: "80rem", margin: "0 auto", padding: "0 1.5rem" }}
        >
          {/* Hero & Info Banner */}
          <section className="mb-16 flex flex-col items-center text-center">
            <h1
              className="font-headline font-extrabold tracking-tight mb-8"
              style={{ color: "#00447f", fontSize: "clamp(2rem, 5vw, 3rem)" }}
            >
              Portail de formulaires électroniques
            </h1>
            <div
              className="w-full rounded-xl p-6 flex items-start gap-4 text-left"
              style={{
                maxWidth: 700,
                backgroundColor: "rgba(212, 227, 255, 0.3)",
              }}
            >
              <span
                className="material-symbols-outlined flex-shrink-0"
                style={{
                  color: "#005ca8",
                  display: "inline-block",
                  lineHeight: 1,
                }}
              >
                info
              </span>
              <p
                className="text-sm leading-relaxed"
                style={{ color: "#414751" }}
              >
                Veuillez noter que vous devez avoir accès à votre adresse
                courriel du centre de services scolaire pour compléter tout
                formulaire, car un code d'authentification sera requis.
              </p>
            </div>
          </section>

          {/* Card Grid — 3 top + 2 centered bottom */}
          <div className="card-grid">
            {cards.map((card, i) => (
              <div
                key={card.to}
                style={{
                  gridColumn:
                    i < 3 ? "span 2" : i === 3 ? "2 / span 2" : "4 / span 2",
                }}
              >
                <div
                  className="rounded-xl p-6 flex flex-col transition-all duration-300"
                  style={{ backgroundColor: "#ffffff", height: "100%" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow =
                      "0 12px 32px rgba(24,28,35,0.08)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div
                    className="mb-6 flex items-center justify-center rounded-lg flex-shrink-0"
                    style={{
                      width: 48,
                      height: 48,
                      backgroundColor: "#f2f3fe",
                      color: "#005ca8",
                    }}
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{
                        fontSize: 28,
                        display: "inline-block",
                        lineHeight: 1,
                      }}
                    >
                      {card.icon}
                    </span>
                  </div>

                  <h3
                    className="font-headline font-bold mb-3 leading-tight"
                    style={{ fontSize: "1.05rem", color: "#181c23" }}
                  >
                    {card.title}
                    {card.subtitle && (
                      <>
                        <br />
                        {card.subtitle}
                      </>
                    )}
                  </h3>

                  <p
                    className="text-sm mb-8 flex-grow"
                    style={{ color: "#60626b" }}
                  >
                    {card.description}
                  </p>

                  {card.disabled ? (
                    <div
                      className="w-full py-2 px-4 rounded-lg font-medium text-sm text-center"
                      style={{
                        backgroundColor: "#e2e4ea",
                        color: "#74777f",
                        cursor: "not-allowed",
                      }}
                    >
                      Temporairement indisponible
                    </div>
                  ) : (
                    <Link
                      to={card.to}
                      className="w-full py-2 px-4 rounded-lg font-medium text-sm text-center transition-all active:scale-95"
                      style={{
                        backgroundColor: "#00447f",
                        color: "#ffffff",
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#005ca8")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "#00447f")
                      }
                    >
                      Accéder au formulaire
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Footer — full width, sticks to bottom */}
      <footer style={{ backgroundColor: "#f2f3fe", width: "100%" }}>
        <div
          className="flex items-center justify-center"
          style={{ padding: "2rem 1.5rem" }}
        >
          <span className="text-xs" style={{ color: "#60626b" }}>
            © 2026 Syndicat de l'enseignement des Vieilles-Forges (SEVF)
          </span>
        </div>
      </footer>
    </div>
  );
}

export default Home;
